import React from 'react';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Tooltip,
  TablePagination,
  Box,
  Typography,
  // IconButton,
  // SvgIcon,
} from '@material-ui/core';
// import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
// import DeleteOutlined from '@material-ui/icons/DeleteOutline';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import { TableSkeleton, dateFormatterTime, dateFormatterDate  } from '@shared/components';
import { ErrorMessage } from './style';

const List = ({
  comments,
  tableColumns,
  page,
  setPage,
  totalCount,
  rowsPerPage,
  setRowsPerPage,
  error,
  loading,
  sorters,
  setSorters,
  handleSortChange,
  getSortDirection,
  // setSelectedComment,
  // setModalVisible,
  // setDeleteModalVisible,
}) => {
  const handleRowsPerPageChange = ({ target: { value } }) => {
    if (value * (page + 1) >= totalCount) setPage(Math.floor(totalCount / value));
    setRowsPerPage(value);
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          {tableColumns.map((column) => (
            <TableCell width={column.width} key={column.value} align={column.align}>
              <Tooltip
                enterDelay={300}
                placement="bottom-start"
                title={`Sortiraj prema ${column.placeholder}`}
              >
                <TableSortLabel
                  active={!!getSortDirection(column.value, sorters)}
                  direction={getSortDirection(column.value, sorters)}
                  onClick={() => handleSortChange(column.value, sorters, setSorters)}
                >
                  {column.name}
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {error ? (
          <TableRow>
            <TableCell align="center" colSpan="100%" height={5 * 70.33}>
              <Box display="flex" justifyContent="center">
                <ErrorOutlineRoundedIcon fontSize="large" />
                <ErrorMessage>{error?.data?.details?.reason || 'Došlo je do greške'}</ErrorMessage>
              </Box>
            </TableCell>
          </TableRow>
        ) : loading || !comments ? (
          <TableRow>
            <TableCell align="center" colSpan="100%">
              <TableSkeleton size={rowsPerPage} />
            </TableCell>
          </TableRow>
        ) : comments?.length === 0 ? (
          <TableRow>
            <TableCell align="center" colSpan="100%" height={80}>
              <Typography>Nije pronađen niti jedan komentar</Typography>
            </TableCell>
          </TableRow>
        ) : (
          comments?.map((comment) => (
            <TableRow
              style={{
                borderBottom: 0,
              }}
              key={comment.id}
            >
              <TableCell width={150}>{comment.createdBy}</TableCell>
              <TableCell width={300}>{comment.documentComment}</TableCell>
              <TableCell width={100}>
                {dateFormatterDate(comment.dateCreated)}
                <Typography variant="h6" color="textSecondary">
                  {dateFormatterTime(comment.dateCreated)}
                </Typography>
              </TableCell>
              <TableCell width={100} align="right">
                {/* <Tooltip enterDelay={300} placement="top-end" arrow title="Uredi komentar">
                  <Box display="inline">
                    <IconButton
                      onClick={() => {
                        setSelectedComment(comment);
                        setModalVisible(true);
                      }}
                    >
                      <SvgIcon fontSize="small">
                        <EditOutlinedIcon />
                      </SvgIcon>
                    </IconButton>
                  </Box>
                </Tooltip>
                <Tooltip enterDelay={300} placement="top-end" arrow title="Obriši komentar">
                  <IconButton
                    onClick={() => {
                      setSelectedComment(comment);
                      setDeleteModalVisible(true);
                    }}
                  >
                    <SvgIcon fontSize="small">
                      <DeleteOutlined />
                    </SvgIcon>
                  </IconButton>
                </Tooltip> */}
              </TableCell>
            </TableRow>
          ))
        )}
        <TableRow>
          <TablePagination
            width="100%"
            count={totalCount}
            page={page}
            labelRowsPerPage="Broj redova po stranici"
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
            rowsPerPageOptions={[5, 10, 20, 25]}
            onPageChange={(_, newPage) => setPage(newPage)}
          />
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default List;
